import React, { useState, useEffect, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { Modal, Paper, Fade, IconButton, Box, Button } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import CameraBrandsModal from "./AddCameraBrandsModal";
import { URL } from "../config";
import axios from "axios";
import toast from "react-hot-toast";

const CameraBrandsList = () => {
  const [dataSource, setDataSource] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editBrand, setEditBrand] = useState(null);

  const fetchBrands = async () => {
    try {
      const res = await axios.get(`${URL}/camerabrands`);
      const formattedData = res.data.data.map((item) => ({
        ...item,
        cameraBrandImage: item.cameraBrandImage ? `${URL}${item.cameraBrandImage}` : "",
      }));
      setDataSource(formattedData);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch brands");
    }
  };

  useEffect(() => { fetchBrands(); }, []);

  const handleEdit = (brand) => { setEditBrand(brand); setModalVisible(true); };
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this brand?")) return;
    try { await axios.delete(`${URL}/camerabrands/${id}`); toast.success("Brand deleted!"); fetchBrands(); }
    catch { toast.error("Delete failed"); }
  };

  const columns = useMemo(() => [
    {
      accessorKey: "actions",
      header: "Actions",
      size: 100,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton size="small" onClick={() => handleEdit(row.original)}>
            <EditIcon sx={{ color: "#174253" }} fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => handleDelete(row.original.cameraBrandId)}>
            <DeleteIcon sx={{ color: "#d32f2f" }} fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
    { accessorKey: "cameraBrandId", header: "ID", size: 60 },
    { accessorKey: "cameraBrandName", header: "Brand Name", size: 150 },
    {
      accessorKey: "cameraBrandImage",
      header: "Image",
      size: 80,
      Cell: ({ row }) =>
        row.original.cameraBrandImage ? (
          <img src={row.original.cameraBrandImage} alt="brand" style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 8, border: "1px solid #ccc" }} />
        ) : (
          <Box sx={{ width: 60, height: 60, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 2, bgcolor: "#f0f0f0" }}>B</Box>
        ),
    },
  ], []);

  return (
    <Box sx={{ width: "100%", bgcolor: "#fff", mt: 2, p: { xs: 1, md: 0 } }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, pr: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", fontWeight: 700, fontSize: 22, color: "#174253", letterSpacing: 0.5, borderLeft: "5px solid #174253", pl: 1.5 }}>
          Camera Brands
        </Box>
        <Button  sx={{
            borderRadius: 25,
            background: "linear-gradient(90deg, #0b8793, #174253)",
            color: "white",
            "&:hover": { background: "linear-gradient(90deg, #174253, #0b8793)" },
          }}
          onClick={() => { setEditBrand(null); setModalVisible(true); }}>
          Add Brand
        </Button>
      </Box>

      <MaterialReactTable
        columns={columns}
        data={dataSource}
        enableColumnActions={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableColumnFilters={false}
        enableHiding={false}
        enableGlobalFilter={false}
        muiTablePaperProps={{ sx: { boxShadow: "none", background: "#fff", borderRadius: "15px" } }}
        muiTableContainerProps={{ sx: { backgroundColor: "#fff", width: "100%", overflowX: "auto", borderRadius: "12px" } }}
        muiTableHeadCellProps={{ sx: { backgroundColor: "#e0e0e0ff", color: "#393e4f", fontWeight: 600, fontSize: "16px", borderBottom: "0.5px solid #e3e5eb", textAlign: "left", height: "63px", paddingTop: "23px" } }}
        muiTableBodyRowProps={{ sx: { backgroundColor: "#fff", "&:hover": { backgroundColor: "#eff6fe" }, "& td": { fontSize: { xs: "12px", sm: "14px" }, p: "8px", borderBottom: "0.5px solid #e3e5eb", height: "54px" } } }}
        initialState={{ pagination: { pageIndex: 0, pageSize: 10 } }}
      />

      <Modal
        open={modalVisible}
        onClose={() => setModalVisible(false)}
        closeAfterTransition
        BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.6)" } }}
      >
        <Fade in={modalVisible}>
          <Paper sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", bgcolor: "transparent", outline: "none" }}>
            <CameraBrandsModal
              brand={editBrand}
              onClose={() => { setModalVisible(false); fetchBrands(); }}
            />
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default CameraBrandsList;
